import React, { useState, useEffect } from 'react';
import { AddInfoKg } from './AddInfoKg';
import { getPCInfo, savePCInfo } from './actions';

const data = require('./data/schema.json');

export const PCAddInfoKg = ({ kgId, close }) => {
  const [initdata, setInitdata] = useState({});

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    const info = await getPCInfo(kgId);

    const updData = (data) => {
      return {
        "6100": data['computers']?.['numbers'] || 0,
        "6110": data['computers']?.['budget'] || 0,
        "6120": data['computers']?.['bad'] || 0,
        "6130": data['computers']?.['fiveold'] || 0,
        "6140": data['computers']?.['managed'] || 0,
        "6150": data['computers']?.['internet_wired'] || 0,
        "6160": data['computers']?.['internet_wifi'] || 0,
        "6170": data['laptops'] || 0,
        "6180": data['pads'] || 0,
        "6210": data['interact']?.['board'] || 0,
        "6220": data['interact']?.['module'] || 0,
        "6230": data['interact']?.['display'] || 0,
        "6310": data['noninteract']?.['projectors'] || 0,
        "6320": data['noninteract']?.['tv'] || 0,
        "6330": data['noninteract']?.['other'] || 0,
        "6400": data['printers'] || 0,
        "6500": data['internetspeedwired'] || 0,
        "6600": data['internetspeedwifi'] || 0
      };
    };

    if (info?.data?.[0]?.['itinfrastructure']) {
      setInitdata(updData(info.data[0]['itinfrastructure']));
    }
  };

  const saveData = async (data) => {
    const data_obj = {
      computers: {
        numbers: data['6100'],
        budget: data['6110'],
        fiveold: data['6130'],
        bad: data['6120'],
        managed: data['6140'],
        internet_wired: data['6150'],
        internet_wifi: data['6160']
      },
      laptops: data['6170'],
      pads: data['6180'],
      interact: {
        board: data['6210'],
        module: data['6220'],
        display: data['6230']
      },
      noninteract: {
        projectors: data['6310'],
        tv: data['6320'],
        other: data['6330']
      },
      printers: data['6400'],
      internetspeedwired: data['6500'],
      internetspeedwifi: data['6600']
    };

    await savePCInfo(kgId, data_obj);
    close();
  };

  return (
    <AddInfoKg 
      data={data} 
      initdata={initdata} 
      save={saveData} 
      close={close}
    />
  );
};